"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconMap = void 0;
var CounterProps_1 = require("./CounterProps");
var attIcon = require("../../../styles/att-icons.css");
exports.iconMap = new Map([
    [CounterProps_1.IconType.ATTICONTV, attIcon.attIconTv],
]);
//# sourceMappingURL=CounterStylesMaps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Counter/CounterStylesMaps.js
// module id = 1133
// module chunks = 8